import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgxStripeModule } from 'ngx-stripe';
import { CookieService } from 'ngx-cookie-service';
import { routes } from './app.routes';
import { environment } from 'src/environments/environment';
import { timeoutInterceptor } from './interceptors/timeout.interceptor';
import { xsrfInterceptor } from './interceptors/xsrf.interceptor';
import { AccountService } from './services/account.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([timeoutInterceptor, xsrfInterceptor]),
      withXsrfConfiguration({ cookieName: 'csrftoken', headerName: 'X-CSRFToken' })
    ),
    provideAnimations(),
    importProvidersFrom(NgxStripeModule.forRoot(environment.stripePublicKey)),
    CookieService,
    // Verify the server session once on bootstrap (awaited) so that the
    // cached user reflects reality before the router / AuthGuard runs.
    // Fixes "stays logged-out after Steam" (get-user-infos was never sent).
    {
      provide: APP_INITIALIZER,
      useFactory: (account: AccountService) => () => account.initSessionCheck(),
      deps: [AccountService],
      multi: true
    }
  ]
};
